import { Text, View } from '@react-pdf/renderer';
import { globalStyles } from "config/pdfStyles";

// const styes = StyleSheet.create({
//   tableHead: {
//     width: 
//   }
// })

const GuardianDetailRowPdf = ({ index, guardian, slug, styles }) => {
  const title = slug === "teacher" ? "Teacher" : slug === "parent" ? "Parent" : "--";
  return (
    <>
      <View style={[styles.tableRow, styles.guardianDetailRow, { borderBottom: "none" }]}>
        <Text style={globalStyles.tableHead}>{title} {index + 1}</Text>
      </View>
      <View style={[styles.tableRow, styles.guardianDetailRow, { borderBottom: "none" }]}>
        <Text style={globalStyles.tableHead}>Last Name:</Text>
        <Text style={globalStyles.tableColumn}>{guardian?.client_guardian?.lastname}</Text>
        <Text style={globalStyles.tableHead}>First Name:</Text>
        <Text style={globalStyles.tableColumn}>{guardian?.client_guardian?.firstname}</Text>
      </View>
      <View style={[styles.tableRow, styles.guardianDetailRow]}>
        <Text style={globalStyles.tableHead}>Email:</Text>
        <Text style={globalStyles.tableColumn}>{guardian?.client_guardian?.email}</Text>
      </View>
    </>
  )
}

export default GuardianDetailRowPdf;